export function getLangName(block, nameKey) {
    let str = '';
    const name = nameKey ? block[nameKey] : block.name;
    const lang = localStorage.getItem('locale') || 'en';
    if (lang === 'zh') {
        str = name;
    }
    else {
        try {
            const names = JSON.parse(block.name_i18n);
            str = names[lang];
        }
        catch (_a) {
            str = name;
        }
    }
    return str;
}
